"use client";

import { useRef } from "react";
import { storeRef } from "./StoreProvider";
import { useDeviceResize } from "@/hooks/app/useDeviceResize";
import { globalActions } from "@/lib/redux/features/global/reduce";

const PageProvider = ({ children, isDesktop }: { children: any, isDesktop: boolean }) => {
  const ref = useRef<boolean>(false)
  useDeviceResize()
  if (!ref.current) {
    storeRef.current?.dispatch(globalActions.setIsDesktop(isDesktop))
    ref.current = true
  }

  return (
    <>
      {children}
    </>
  ) 
}

export default PageProvider